module.exports = __webpack_public_path__ + "static/media/megalore.a7d7aac1.svg";